import { gql } from "@apollo/client";

export const SALES_METRICS_REPORT_V4 = gql`
  query GetSalesMetricsReportV4(
    $accountingMode: String!
    $attributionModel: String!
    $attributionWindow: String!
    $level: String!
    $timeGranularity: String!
    $dateRange: SalesDateRangeInput!
    $compareDateRange: SalesDateRangeInput
    $dimensionIds: [String!]!
    $metricIds: [String!]!
    $advancedSearch: JSONObject
    $breakdownFilters: [SalesTableReportV3BreakdownsFilterInput!]
    $campaignFilters: [String!]
    $adsetFilters: [String!]
    $adFilters: [String!]
    $metricFilters: [SalesMetricFilterInput!]
    $sorting: [SalesSortingInput!]
    $limit: Int
    $offset: Int
    $isSummary: Boolean
  ) {
    me {
      salesMetricsReportV4(
        accountingMode: $accountingMode
        attributionModel: $attributionModel
        attributionWindow: $attributionWindow
        level: $level
        timeGranularity: $timeGranularity
        dateRange: $dateRange
        compareDateRange: $compareDateRange
        dimensionIds: $dimensionIds
        metricIds: $metricIds
        advancedSearch: $advancedSearch
        breakdownFilters: $breakdownFilters
        campaignFilters: $campaignFilters
        adsetFilters: $adsetFilters
        adFilters: $adFilters
        metricFilters: $metricFilters
        sorting: $sorting
        limit: $limit
        offset: $offset
        isSummary: $isSummary
      ) {
        actual
        comparison
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }
      }
    }
  }
`;

export const SALES_METRICS_COUNT_V4 = gql`
  query GetSalesMetricsCountV4(
    $accountingMode: String!
    $attributionModel: String!
    $attributionWindow: String!
    $level: String!
    $timeGranularity: String!
    $dateRange: SalesDateRangeInput!
    $compareDateRange: SalesDateRangeInput
    $dimensionIds: [String!]!
    $metricIds: [String!]!
    $advancedSearch: JSONObject
    $campaignFilters: [String!]
    $adsetFilters: [String!]
    $adFilters: [String!]
    $breakdownFilters: [SalesTableReportV3BreakdownsFilterInput!]
    $metricFilters: [SalesMetricFilterInput!]
  ) {
    me {
      salesMetricsCountV4(
        accountingMode: $accountingMode
        attributionModel: $attributionModel
        attributionWindow: $attributionWindow
        level: $level
        timeGranularity: $timeGranularity
        dateRange: $dateRange
        compareDateRange: $compareDateRange
        dimensionIds: $dimensionIds
        metricIds: $metricIds
        advancedSearch: $advancedSearch
        campaignFilters: $campaignFilters
        adsetFilters: $adsetFilters
        adFilters: $adFilters
        breakdownFilters: $breakdownFilters
        metricFilters: $metricFilters
      ) {
        total
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }
      }
    }
  }
`;

export const CONVERSION_LAG_REPORT_V4 = gql`
  query GetConversionLagReportV4(
    $accountingMode: String!
    $attributionModel: String!
    $attributionWindow: String!
    $level: String!
    $timeGranularity: String!
    $dateRange: SalesDateRangeInput!
    $compareDateRange: SalesDateRangeInput
    $dimensionIds: [String!]!
    $metricIds: [String!]!
    $advancedSearch: JSONObject
    $campaignFilters: [String!]
    $adsetFilters: [String!]
    $adFilters: [String!]
    $breakdownFilters: [SalesTableReportV3BreakdownsFilterInput!]
    $metricFilters: [SalesMetricFilterInput!]
  ) {
    me {
      conversionLagReportV4(
        accountingMode: $accountingMode
        attributionModel: $attributionModel
        attributionWindow: $attributionWindow
        level: $level
        timeGranularity: $timeGranularity
        dateRange: $dateRange
        compareDateRange: $compareDateRange
        dimensionIds: $dimensionIds
        metricIds: $metricIds
        advancedSearch: $advancedSearch
        campaignFilters: $campaignFilters
        adsetFilters: $adsetFilters
        adFilters: $adFilters
        breakdownFilters: $breakdownFilters
        metricFilters: $metricFilters
      ) {
        conversionLag {
          attributionWindow
          rev
          revFt
          revRtn
          txns
          txnsFt
          txnsRtn
          roas
          roasFt
          roasRtn
          newCac
          newCacFt
          newCacRtn
        }
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }
      }
    }
  }
`;
